import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrowOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 11, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.6667 4.66667H2.55333L6.28 0.94L5.33333 0L0 5.33333L5.33333 10.6667L6.27333 9.72667L2.55333 6H10.6667V4.66667Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgLeftArrowOutline);
export { ForwardRef as ReactComponent };
